const ta = {
  language_label: 'மொழி',
  language_english: 'ஆங்கிலம்',
  language_tamil: 'தமிழ்',
  module_navigation_aria: '{module} வழிசெலுத்தல்',
  common_logout: 'வெளியேறு',
  common_module_not_found: 'மாட்யூல் கிடைக்கவில்லை',
  app_desktop_only_description:
    'இந்த மாட்யூல் டெஸ்க்டாப் திரைக்காக மேம்படுத்தப்பட்டுள்ளது. முழு அனுபவத்திற்காக லேப்டாப் அல்லது டெஸ்க்டாப்-ல் திறக்கவும்.',
  app_go_back: 'பின்னுக்கு செல்',
  followup_brand_name: 'பின்தொடர்வுகள்',

  reception_brand_name: 'ரிசெப்ஷன்',
  reception_brand_sub: 'முன் மேசை',
  reception_role_front_desk: 'முன் மேசை',
  reception_alert_recalls: 'ரீகால்',
  reception_alert_online: 'ஆன்லைன்',
  reception_search_patient: 'நோயாளியை தேடவும்...',
  reception_open_pharmacy: 'Pharmacy மாட்யூலைத் திறக்கவும்',
  reception_open_pharmacy_label: 'Pharmacy ↗',
  reception_view_queue: 'க்யூ',
  reception_view_calendar: 'காலண்டர்',
  reception_tab_new_patient: 'புதிய நோயாளர்',
  reception_tab_backdate_visit: 'பழைய தேதி வருகை',
  reception_tab_visit_history: 'வருகை வரலாறு',
  reception_section_today_registration: 'இன்றைய பதிவு',
  reception_section_today_registration_sub:
    'உடனடி நியமனத்திற்காக புதிய walk-in நோயாளியை பதிவு செய்யவும்.',
  reception_section_old_record: 'பழைய பதிவு உள்ளீடு',
  reception_section_old_record_sub: 'புத்தகத்தில் உள்ள பழைய வருகையை டிஜிட்டல் வடிவத்திற்கு மாற்றவும்.',

  doctor_brand_name: 'கிளினிக்கல்',
  doctor_brand_sub: 'மருத்துவர் நிலையம்',
  doctor_role_default: 'மருத்துவர்',
  doctor_role_clinician: 'கிளினீஷியன்',
  doctor_tab_dashboard: 'டாஷ்போர்டு',
  doctor_tab_notes: 'குறிப்புகள்',
  doctor_tab_toothchart: 'பல் வரைபடம்',
  doctor_tab_treatment_plan: 'சிகிச்சை திட்டம்',
  doctor_tab_perio: 'பெரியோ',
  doctor_tab_history: 'வரலாறு',
  doctor_tab_prescriptions: 'மருந்து சீட்டுகள்',
  doctor_tab_review_sign: 'சரிபார்த்து கையொப்பமிடு',
  doctor_error_start_session: 'அமர்வை தொடங்க முடியவில்லை.',
  doctor_error_open_visit: 'திட்டமிட்ட வருகையைத் திறக்க முடியவில்லை.',
  doctor_dashboard_title: 'மருத்துவ கட்டுப்பாட்டு அறை',
  doctor_dashboard_subtitle: 'உங்கள் தினசரி அட்டவணை மற்றும் வருகைகளை நிர்வகிக்கவும்.',
  doctor_dashboard_waiting_room: 'காத்திருப்பு அறை',
  doctor_dashboard_completed: 'முடிந்தது',
  doctor_dashboard_jump_to_date: 'தேதிக்கு செல்',
  doctor_dashboard_clinical_ops: 'கிளினிக்கல் செயல்பாடுகள்',
  doctor_dashboard_open_module: 'மாட்யூலை திறக்க ↗',
  doctor_dashboard_quick_start: 'விரைவு தொடக்கம் (Walk-in)',
  doctor_dashboard_quick_start_sub: 'நோயாளியை தேடி இன்றைய வருகையைத் திறக்கவும்.',

  manager_brand_name: 'மேனேஜர்',
  manager_brand_sub: 'செயல்பாடுகள்',
  manager_role_default: 'மேனேஜர்',
  manager_tab_dashboard: 'டாஷ்போர்டு',
  manager_tab_billing: 'பில்லிங்',
  manager_tab_inventory: 'இன்வென்டரி',
  manager_tab_consultants: 'கன்சல்டன்ட்கள்',
  manager_tab_labs: 'லேப்கள்',
  manager_tab_finance_reports: 'நிதி அறிக்கைகள்',
  manager_tab_patient_history: 'நோயாளர் வரலாறு',
  manager_tab_clinic_notes: 'கிளினிக் குறிப்புகள்',
  manager_alert_low_stock: 'குறைந்த இருப்பு',
  manager_dashboard_clinical_operations: 'கிளினிக்கல் செயல்பாடுகள்',
  manager_dashboard_launch_module: 'மாட்யூலை தொடங்கு ↗',
  manager_dashboard_clinical_billing: 'கிளினிக்கல் பில்லிங் ↗',
  manager_dashboard_clinical_operations_sub:
    'எண்டோடான்டிக்ஸ், எக்ஸ்ட்ராக்ஷன்ஸ், ஆர்தோ மற்றும் பிற கிளினிக்கல் செயல்முறைகளை தனி விண்டோவில் நிர்வகிக்கவும்.',
  manager_consultant_select_hint: 'லெட்ஜரை பார்க்க ஒரு கன்சல்டன்டைத் தேர்ந்தெடுக்கவும்',

  pharmacy_brand_name: 'Pharmacy Console',
  pharmacy_navigation_aria: 'Pharmacy மாட்யூல்கள்',
  pharmacy_tab_billing_dispense: 'பில்லிங் & வழங்கல்',
  pharmacy_tab_sales_history: 'விற்பனை வரலாறு',
  pharmacy_tab_stock_inventory: 'ஸ்டாக் இன்வென்டரி',
  pharmacy_tab_suppliers: 'Pharmacy சப்ளையர்கள்',
  pharmacy_tab_drug_notes: 'மருந்து குறிப்புகள்',
  pharmacy_tab_clinic_letters: 'கிளினிக் கடிதங்கள்',

  mobile_brand_eyebrow: 'ஒருங்கிணைந்த மொபைல் வேலைப்பரப்பு',
  mobile_brand_title: 'CareFlow Mobile',
  mobile_nav_aria: 'மொபைல் CareFlow வழிசெலுத்தல்',
  mobile_tab_careflow: 'CareFlow 360',
  mobile_tab_careflow_short: 'Care',
  mobile_tab_billing: 'பில்லிங்',
  mobile_tab_billing_short: 'Bill',
  mobile_tab_pharmacy: 'Pharmacy',
  mobile_tab_pharmacy_short: 'Rx',
  mobile_tab_finance: 'நிதி',
  mobile_tab_finance_short: 'Money',
  mobile_tab_apps: 'மாட்யூல்கள்',
  mobile_tab_apps_short: 'Apps',
  mobile_tab_rct_queue: 'RCT Queue',
  mobile_tab_rct_queue_short: 'Queue',
  mobile_select_patient_title: 'CareFlow திறக்க நோயாளியை தேர்ந்தெடுக்கவும்',
  mobile_select_patient_sub:
    'மேலே உள்ள தேடலில் நோயாளியை தேர்ந்தெடுக்கவும். இன்றைய வருகை தானாக திறந்து நேரலை ஒத்திசைவு தொடங்கும்.',
  mobile_billing_empty_title: 'பில்லிங்கிற்கு செயலில் இருக்கும் வருகை தேவை',
  mobile_billing_empty_sub:
    'முதலில் நோயாளியை தேர்ந்தெடுத்து சரியான வருகைக்கே இன்வாய்ஸ் மற்றும் நிலுவை இணைக்கப்படும்படி செய்யவும்.',
  mobile_rct_queue_title: 'நேரடி RCT Queue',
  mobile_live_label: 'நேரலை',
  mobile_app_reception: 'ரிசெப்ஷன் மேசை',
  mobile_app_reception_sub: 'பதிவு, க்யூ, மற்றும் நேரமிடல்',
  mobile_app_doctor: 'மருத்துவர் நிலையம்',
  mobile_app_doctor_sub: 'மருத்துவ வரைபடம் மற்றும் மதிப்பாய்வு',
  mobile_app_manager: 'மேனேஜர் கன்சோல்',
  mobile_app_manager_sub: 'செயல்பாடு மற்றும் நிர்வாக கட்டுப்பாடுகள்',
  mobile_app_treatments: 'சிகிச்சைகள்',
  mobile_app_treatments_sub: 'Clinical procedure workflows',
  mobile_app_pharmacy: 'Pharmacy Console',
  mobile_app_pharmacy_sub: 'மருந்து வழங்கல் மற்றும் ஸ்டாக் மேலாண்மை',
  mobile_end_session: 'அமர்வை முடி',
  mobile_unknown_patient: 'அறியப்படாத நோயாளர்',
  mobile_no_phone: 'தொலைபேசி இல்லை',
  mobile_visit_label: 'வருகை',
  mobile_syncing: 'ஒத்திசைக்கிறது',
  mobile_ready: 'தயார்',

  backup_title: 'காப்புப்பிரதிகள்',
  backup_auto_policy: 'தானியங்கி காப்பு கொள்கை',
  backup_save_policy: 'கொள்கையை சேமி',
  backup_saving_policy: 'சேமிக்கிறது...',
  backup_enable_scheduler: 'அட்டவணையை இயக்கவும்',
  backup_upload_drive: 'Drive-இல் பதிவேற்று',
  backup_frequency: 'அதிர்வெண்',
  backup_frequency_daily: 'தினசரி',
  backup_frequency_weekly: 'வாரந்தோறும்',
  backup_frequency_biweekly: 'இரு வாரத்திற்கு ஒரு முறை',
  backup_frequency_monthly: 'மாதந்தோறும்',
  backup_run_hour_utc: 'இயக்கும் மணி (UTC)',
  backup_run_minute_utc: 'இயக்கும் நிமிடம் (UTC)',
  backup_retention_days: 'பாதுகாப்பு நாட்கள்',
  backup_max_backups: 'அதிகபட்ச காப்புகள்',
  backup_next_run: 'அடுத்த இயக்கம்',
  backup_last_run: 'கடைசி இயக்கம்',

  careflow_title: 'Apexo பாணி பல் வரைபடம்',
  careflow_subtitle:
    'சிகிச்சை நிகழ்வுகள், பல் வரலாறு, ஒத்துழைப்பு குறிப்புகள் மற்றும் மோதல் பாதுகாப்பு ஒத்திசைவு.',
  careflow_stream_version: 'ஸ்ட்ரீம் பதிப்பு',
  careflow_updated: 'புதுப்பிப்பு',
  careflow_hello: 'வணக்கம்',
  careflow_appointments_today: 'இன்றைய சந்திப்புகள்',
  careflow_new_patients_today: 'இன்றைய புதிய நோயாளிகள்',
  careflow_payments_made_today: 'இன்று செய்யப்பட்ட செலுத்துதல்கள்',
  careflow_qr_button: 'நோயாளர் QR',
  careflow_qr_title: 'நோயாளர் QR குறியீடு',
  careflow_qr_close: 'மூடு',
  careflow_view_timeline: 'காலவரிசை பார்வை',
  careflow_view_kanban: 'கன்பன் பார்வை',
  careflow_clinical_timeline: 'மருத்துவ காலவரிசை',
  careflow_current_treatments: 'தற்போதைய வருகை: சிகிச்சைகள்',
  careflow_current_history: 'தற்போதைய வருகை: பல் வரலாறு',
  careflow_no_treatment_events: 'இந்த வருகைக்கு சிகிச்சை நிகழ்வுகள் இல்லை.',
  careflow_no_history_entries: 'இந்த வருகைக்கு பல் வரலாறு பதிவுகள் இல்லை.',
  careflow_past_records: 'முந்தைய பதிவுகள்',
  careflow_audit_trail: 'தணிக்கை தடம்',
  careflow_collab_notes: 'ஒத்துழைப்பு குறிப்புகள்',
  careflow_collab_audit: 'ஒத்துழைப்பு தணிக்கை',
  careflow_collab_none: 'இந்த வருகைக்கு ஒத்துழைப்பு குறிப்புகள் இல்லை.',
  careflow_add_history: 'வரலாறு சேர்க்க',
  careflow_history_tooth: 'பல் #',
  careflow_history_label: 'வரலாறு குறிப்பு',
  careflow_history_note: 'விருப்ப குறிப்பு',
  careflow_remove: 'அகற்று',
  careflow_add_note: 'குறிப்பு சேர்க்க',
  careflow_add_note_saving: 'சேமிக்கிறது...',
  careflow_collab_note_placeholder: 'இந்த வருகைக்கான ஒத்துழைப்பு குறிப்பை சேர்க்கவும்...',
  careflow_collab_mentions_placeholder: 'Mention-கள் (கமா பிரித்து)',
  careflow_delete: 'நீக்கு',
  careflow_live_status: 'நேரலை',
  careflow_live_connecting: 'இணைக்கப்படுகிறது',
  careflow_live_open: 'இணைக்கப்பட்டது',
  careflow_live_closed: 'இணைப்பு துண்டிக்கப்பட்டது',
  careflow_live_error: 'இணைப்பு பிழை',
  careflow_live_unauthenticated: 'அங்கீகாரம் தேவை',
  careflow_tags_placeholder: 'வருகை டேக் சேர்க்கவும் (உதா: அவசரம், பின்தொடர்பு)...',
  careflow_tags_saving: 'டேக் சேமிக்கிறது...',
  careflow_tags_conflict: 'மற்றொரு அமர்விலிருந்து டேக் இணைக்கப்பட்டது.',
  careflow_tags_error: 'டேக் ஒத்திசைவு தோல்வி. அடுத்த மாற்றத்தில் மீண்டும் முயலும்.',
  careflow_tags_synced_at: 'டேக் ஒத்திசைவு நேரம் {when}',
  careflow_tooth_prefix: 'பல்',
  careflow_event_label: 'நிகழ்வு',
  careflow_historical_label: 'வரலாற்று',
  careflow_general_label: 'பொது',
  careflow_mentions_label: 'Mention-கள்',
  careflow_note_prefix: 'குறிப்பு #',
  portal_title: 'தைலா டெண்டல் நோயாளர் போர்டல்',
  portal_subtitle: 'வரவிருக்கும் நியமனங்களை பார்க்கவும், புதிய பதிவு கேட்கவும்.',
  portal_find_title: 'என் நியமனங்களை காண்க',
  portal_request_title: 'நியமனம் கோருக',
  portal_mobile_placeholder: 'மொபைல் எண்',
  portal_name_placeholder: 'முழுப் பெயர்',
  portal_view_btn: 'நியமனங்களை காண்க',
  portal_empty: 'வரவிருக்கும் நியமனங்கள் இல்லை.',
  portal_status_open: 'திறந்தது',
  portal_age_placeholder: 'வயது',
  portal_gender_placeholder: 'பாலினம்',
  portal_gender_male: 'ஆண்',
  portal_gender_female: 'பெண்',
  portal_gender_other: 'மற்றது',
  portal_doctor_placeholder: 'விருப்ப மருத்துவர் (விருப்பம்)',
  portal_notes_placeholder: 'குறிப்புகள் / கவலைகள்',
  portal_request_btn: 'கோரிக்கை அனுப்பு',
  portal_error_missing: 'மொபைல் எண் மற்றும் பெயர் தேவை.',
  portal_error_lookup: 'நியமனங்கள் கிடைக்கவில்லை. பெயர் + மொபைல் சரிபார்க்கவும்.',
  portal_request_success: 'நியமன கோரிக்கை அனுப்பப்பட்டது. விரைவில் தொடர்பு கொள்வோம்.',
  portal_request_fail: 'கோரிக்கை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
};

export default ta;
